// Mirror of App\Enums\DraftStatus (campdraftone-api) — `drafts.draft_status_id`. Keep in sync by
// hand; there is no shared source of truth across the two repos. Labels are NOT duplicated here —
// the API sends the ready-to-display `draft_status_label` (DraftStatus::label()) on each row,
// same pattern as `nomination_status_label` elsewhere, so the frontend never re-derives status text.
export const DRAFT_STATUS_PENDING = 1
export const DRAFT_STATUS_PUBLISHED = 2
export const DRAFT_STATUS_POSTPONED = 3
export const DRAFT_STATUS_CANCELLED = 4



// WEBPACK FOOTER //
// ./src/constants/draftStatus.js